<template>
  <div id="app" :class="getClass">
    <Footer
      v-if="$route.meta.activeTabId"
      :activeId="$route.meta.activeTabId"
    ></Footer>
    <Header v-if="$route.meta.hasBanner"></Header>
    <keep-alive>
      <router-view />
    </keep-alive>
    <!-- <text-ellipsis/> -->
    <float-audio></float-audio>
  </div>
</template>

<script>
import TextEllipsis from "@/components/TextEllipsis";
import Header from "@/components/header";
import Footer from "@/components/footer";
import floatAudio from "@/components/floatAudio";
export default {
  name: "App",
  components: {
    TextEllipsis,
    Header,
    floatAudio,
    Footer,
  },
  computed: {
    getClass() {
      if (this.$route.path == "/" || this.$route.path == "/prod") {
        return "prod-bag";
      } else if(this.$route.path == '/assistant') {
        return "assi-bag";
      }
      return "";
    },
  },
  methods: {},
};
</script>

<style>
/* 阿里字体图标设置 */
.icon,
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  /*max-width: 900px;*/
  margin: 0 auto;
  background: linear-gradient(
    90deg,
    rgb(239, 242, 247) 0%,
    7.60286%,
    rgb(237, 240, 249) 15.2057%,
    20.7513%,
    rgb(235, 239, 248) 26.297%,
    27.6386%,
    rgb(235, 239, 248) 28.9803%,
    38.2826%,
    rgb(231, 237, 249) 47.585%,
    48.1216%,
    rgb(230, 236, 250) 48.6583%,
    53.1306%,
    rgb(228, 236, 249) 57.6029%,
    61.5385%,
    rgb(227, 234, 250) 65.4741%,
    68.7835%,
    rgb(222, 234, 250) 72.093%,
    75.7603%,
    rgb(219, 230, 248) 79.4275%,
    82.8265%,
    rgb(216, 229, 248) 86.2254%,
    87.8354%,
    rgb(213, 228, 249) 89.4454%,
    91.8605%,
    rgb(210, 226, 249) 94.2755%,
    95.4383%,
    rgb(209, 225, 248) 96.6011%,
    98.3005%,
    rgb(208, 224, 247) 100%
  );
}
.prod-bag {
  background: #faeade !important;
}
.assi-bag {
  /* background: #faeade !important; */
  background: linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%) !important;
}
#app .home-container {
  flex: 1;
}
*::-webkit-scrollbar {
  display: none;
}
* {
  scrollbar-width: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue